import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/format";
import Link from "../../utils/Link";
import { useApi } from "../../utils/useApi";

import "./style.scss";

const Exchange = () => {
  const { t } = useTranslation();
  const [selectedCurrency, setSelectedCurrency] = useState("EUR");
  const { loading, data = [] } = useApi("/tools/exchange");

  if (data.statusCode) {
    return null;
  }

  const currencies = data
    .filter((i) => i.Currency2 === "ALL")
    .map((i) => i.Currency1);

  const selected = data.find((i) => i.Currency1 == selectedCurrency);

  return (
    <div className="currency__item">
      <div className="currency__item-inner">
        <div className="currency__header">
          <div className="currency__header-left">
            <div className="currency__title">
              <font>
                <font>{t("exchange.title")}</font>
              </font>
            </div>
            <p>
              <font>
                <font>{formatDate(new Date())} | </font>
              </font>
              <Link to="/tools/exchange">
                <font>
                  <font>{t("exchange.seeAllRates")}</font>
                </font>
              </Link>
            </p>
          </div>
          <div className="currency__header-right">
            <div className="select select--outline">
              <select
                onChange={(e) => setSelectedCurrency(e.target.value)}
                className="js-update__currency"
              >
                {currencies.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="currency__body">
          {!loading && selected ? (
            <div className="currency__block currency__block-currency el-show">
              <ul className="currency__list">
                <li className="currency__list-item">
                  <div className="currency__list-inner">
                    <p className="currency__list-title">
                      <font>
                        <font>{t("exchange.buy")}</font>
                      </font>
                    </p>
                    <p className="currency__list-price">
                      <span className="currency__list-price-value">
                        <font>
                          <font>{selected.Buy}</font>
                        </font>
                      </span>
                      <font>
                        <font>lek</font>
                      </font>
                    </p>
                  </div>
                </li>

                <li className="currency__list-item">
                  <div className="currency__list-inner">
                    <p className="currency__list-title">
                      <font>
                        <font>{t("exchange.sell")}</font>
                      </font>
                    </p>
                    <p className="currency__list-price">
                      <span className="currency__list-price-value">
                        <font>
                          <font>{selected.Sell}</font>
                        </font>
                      </span>
                      <font>
                        <font>lek</font>
                      </font>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Exchange;
